app.controller('modalOtoritasCtrl', function ($scope, $uibModalInstance, urlServices, toaster, params) {
    $scope.userid = params.userid;
    $scope.activeTab = 0;
    $scope.deptList = [];
    $scope.tabs = [
        { type: 'approve_pr', label: 'Approve PR', selected: {}, search: '' },
        { type: 'reject_pr', label: 'Reject PR', selected: {}, search: '' },
        { type: 'approve_po', label: 'Approve PO', selected: {}, search: '' },
        { type: 'reject_po', label: 'Reject PO', selected: {}, search: '' },
        { type: 'pr_view', label: 'PR View', selected: {}, search: '' },
        { type: 'po_view', label: 'PO View', selected: {}, search: '' },
        { type: 'receive_view', label: 'Receive View', selected: {}, search: '' },
        { type: 'delete_outbound', label: 'Delete Outbound', selected: {}, search: '', userScoped: true },
        { type: 'delete_ewaybill', label: 'Delete E-Waybill', selected: {}, search: '', userScoped: true },
        { type: 'ewaybill_reprint', label: 'Reprint E-Waybill', selected: {}, search: '', userScoped: true },
        { type: 'ewaybill_reprint_override', label: 'Override Limit E-WayBill', selected: {}, search: '', userScoped: true }
    ];

    function isUserScopedTab(tab) {
        return !!(tab && tab.userScoped);
    }

    $scope.pilihSemua = function (tab) {
        if (isUserScopedTab(tab)) {
            tab.selected.__USER__ = true;
            return;
        }
        for (var i = 0; i < $scope.deptList.length; i++) {
            tab.selected[$scope.deptList[i].Dept] = true;
        }
    };
    $scope.batalPilih = function (tab) {
        if (isUserScopedTab(tab)) {
            tab.selected.__USER__ = false;
            return;
        }
        for (var i = 0; i < $scope.deptList.length; i++) {
            tab.selected[$scope.deptList[i].Dept] = false;
        }
    };

    $scope.simpanOtoritas = function () {
        var items = [];
        for (var t = 0; t < $scope.tabs.length; t++) {
            var tab = $scope.tabs[t];
            if (isUserScopedTab(tab)) {
                if (tab.selected.__USER__) {
                    items.push({ otoritas_type: tab.type, dept: '' });
                }
                continue;
            }
            for (var dept in tab.selected) {
                if (tab.selected[dept]) {
                    items.push({ otoritas_type: tab.type, dept: dept });
                }
            }
        }
        urlServices.simpanData('api/user/' + $scope.userid + '/otoritas', { items: items }, function (g, s) {
            if (g) {
                toaster.pop('error', 'Error', g.err || 'Gagal menyimpan otoritas');
            } else {
                toaster.pop('success', 'Otoritas', 'Otoritas disimpan');
                $uibModalInstance.close(true);
            }
        });
    };

    // Load dept list and existing otoritas
    urlServices.ambilData('api/deptlist', {}, function (e, d) {
        if (d) {
            $scope.deptList = d;
        }
        // Load existing otoritas
        urlServices.ambilData('api/user/' + $scope.userid + '/otoritas', {}, function (e2, d2) {
            if (d2 && d2.length > 0) {
                for (var i = 0; i < d2.length; i++) {
                    var row = d2[i];
                    for (var t = 0; t < $scope.tabs.length; t++) {
                        if ($scope.tabs[t].type === row.otoritas_type) {
                            if (isUserScopedTab($scope.tabs[t])) {
                                $scope.tabs[t].selected.__USER__ = true;
                            } else {
                                $scope.tabs[t].selected[row.dept] = true;
                            }
                        }
                    }
                }
            }
        });
    });
});
